'use client';

import { forwardRef } from 'react';
import type { ButtonProps } from '@mui/material';
import { styled } from '@mui/material/styles';
import CustomButton from './CustomButton';
import { BRAND } from '@/theme/brand-tokens';

const ACTIVE_COLOR = BRAND.teal;

interface DashboardFilterButtonProps extends Omit<ButtonProps, 'variant'> {
  active?: boolean;
}

// Styled layer — only overrides outlined styles when active prop is true.
// Uses && for higher specificity than CustomButton's .MuiButton-outlined rule.
const StyledFilterButton = styled(CustomButton, {
  shouldForwardProp: (prop) => prop !== 'active',
})<DashboardFilterButtonProps>(({ active }) => ({
  ...(active && {
    '&&.MuiButton-outlined': {
      color: ACTIVE_COLOR,
      borderColor: ACTIVE_COLOR,
      backgroundColor: `${ACTIVE_COLOR}1A`,
      '&:hover': {
        color: ACTIVE_COLOR,
        borderColor: ACTIVE_COLOR,
        backgroundColor: `${ACTIVE_COLOR}26`,
      },
    },
  }),
}));

// Wrapper always forces variant="outlined" so callers don't need to pass it.
const DashboardFilterButton = forwardRef<HTMLButtonElement, DashboardFilterButtonProps>(
  ({ active, ...props }, ref) => (
    <StyledFilterButton ref={ref} variant="outlined" active={active} {...props} />
  )
);

DashboardFilterButton.displayName = 'DashboardFilterButton';

export default DashboardFilterButton;
